import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import {curveGeometryAttributeSetLike} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {CurveGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {GetAttributeParameters} from "#template/nodes/geometry-graph/attribute/get-attribute/geometry-get-attribute-node"
import {GeometryGetAttributeNode, getAttributeParametersSchema} from "#template/nodes/geometry-graph/attribute/get-attribute/geometry-get-attribute-node"

export type CurveGeometryGetAttributeParameters = GetAttributeParameters<CurveGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<CurveGeometryGetAttributeParameters> = {
    nodeClass: "CurveGeometryGetAttribute",
    validation: {
        parameters: getAttributeParametersSchema(curveGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryGetAttribute extends GeometryGetAttributeNode<1, CurveGeometryAttributeSetLikeNode> implements CurveGeometryAttributeLikeNode {
    get [curveGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
